import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { HttpClientModule } from '@angular/common/http';
import { ActivateMemberV2RoutingModule } from './activate-member-v2-routing.module';
import { ActivateMemberV2Component } from './activate-member-v2.component';
import { SearchModule } from '../search/search.module';
import { CardsModule } from '../shared/cards/cards.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    ActivateMemberV2RoutingModule,
    HttpClientModule,
    SearchModule,
    CardsModule,
    FormsModule
  ],
  declarations: [ActivateMemberV2Component]
})
export class ActivateMemberV2Module {}
